var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content-wrapper"},[_c('div',{staticClass:"main-content-box px-3"},[_c('RevenueAndProfit')],1),_c('div',{staticClass:"main-content-box mt-1 p-3"},[_c('RevenueAndProfitLineChartContainer',{attrs:{"title":_vm.translations('dashboard.performance_trend_chart')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }